/*
 * @Description: 操作日志路由
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const systemJournalRouter: Array<RouteRecordRaw> = [
	{
		path: '/systemJournal',
		component: Layout,
		redirect: '/systemJournal/systemJournalList',
		children: [
			{
				path: 'systemJournalList',
				component: () => import(/* webpackChunkName: "SystemJournalList" */ '@/views/systemJournal/index.vue'),
				name: 'SystemJournalList',
				meta: { title: '系统日志' }
			}
		]
	}
]

export default systemJournalRouter
